export default __webpack_public_path__ + "static/media/nex-arrow-back.8d1da056.svg";